import type { Price } from '../../../../ssr/src/Outlet/ShoppingCart/ShoppingCartSchema';

interface PricesState {
    discount: Price;
    discountCode: string;
    hasDiscount: boolean;
    isDiscountCodeValid: boolean;
    shippingPrice: Price;
    subTotal: Price;
    total: Price;
    voucher: Price;
    voucherCode: string;
}

const initialPricesState: PricesState = {
    discount: {
        currency: 'EUR',
        value: 0,
    },
    discountCode: '',
    hasDiscount: false,
    isDiscountCodeValid: true,
    shippingPrice: {
        currency: 'EUR',
        value: 0,
    },
    subTotal: {
        currency: 'EUR',
        value: 0,
    },
    total: {
        currency: 'EUR',
        value: 0,
    },
    voucher: {
        currency: 'EUR',
        value: 0,
    },
    voucherCode: '',
};

export type { PricesState };
export default initialPricesState;
